import axios from 'axios'
import createStore from 'unistore'
import devtools from 'unistore/devtools.js'
import getFingerprint from './getFingerprint.jsx'
import {
  getInstantQuoteSourceLanguage,
  getInstantQuoteTargetLanguages,
  translatedLocalStorageKeys,
} from '../Services/storage.jsx'
import { getApiUrl } from '../Services/helpers.jsx'

Storage.prototype.set = (key, value) =>
  window.localStorage.setItem(key, JSON.stringify(value))

Storage.prototype.get = (key) => JSON.parse(window.localStorage.getItem(key))

Storage.prototype.remove = (key) => window.localStorage.removeItem(key)

axios.defaults.baseURL = getApiUrl()

const fingerprint = getFingerprint()

axios.interceptors.request.use((request) => {
  request.params = request.params || {}
  request.params.token =
    window.localStorage.getItem('token') ||
    window.localStorage.getItem('currentUserToken@translated.com')
  request.params.fingerprint = fingerprint
  // request.params.referrer = window.localStorage.getItem('referrer');
  return request
})

axios.interceptors.response.use((response) => {
  if (response.data?.new_token) {
    window.localStorage.setItem('token', response.data.token)
    window.localStorage.setItem(
      'currentUserToken@translated.com',
      response.data.new_token,
    )
  }

  if (response.data?.token) {
    window.localStorage.setItem('token', response.data.token)
    window.localStorage.setItem(
      translatedLocalStorageKeys.currentUserToken,
      response.data.token,
    )
  }

  return response
})

export const initialState = {
  token: null,
  me: null,
  //
  uploaderIsVisible: window.location.search.startsWith('?uploader'),
  // quote: step1
  quoteCode: '',
  source: getInstantQuoteSourceLanguage() || 'it-IT', //tofix: load defaults
  targets: getInstantQuoteTargetLanguages() || 'en-GB', //tofix: load defaults
  files: [],
  filesMap: {},
  wordCount: 0,
  wordCountTouched: false,
  subject: null,
  deliveryDate: null,
  isQuoting: false,
  projectEconomy: null,
  projectProfessional: null,
  projectPremium: null,
  // quote: step2
  projectId: null,
  projectName: '',
  deliveryEmail: '',
  notes: '',
  // quote: step3
  email: '',
  password: '',
  isBusiness: false,
  privateName: '',
  companyName: '',
  fiscalCode: '',
  vatNumber: '',
  phone: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  postalCode: '',
  country: '',
  timezone: '',
  language: '',
  confirmResult: null,
  // contact-us
  contactEmail: '',
  contactName: '',
  contactFiles: [],
  contactMessage: '',
  contactResult: null,
}

try {
  const savedState = window.localStorage.get('state')
  // apply initial consistency checks
  if (savedState) {
    Object.assign(initialState, savedState)
    // preserve ?upload param to open uploader on page load
    initialState.uploaderIsVisible =
      window.location.search.startsWith('?uploader')
    // any that was still being uploading is now failed because page was reloaded
    savedState.files
      .filter((file) => file.uploading)
      .forEach((file) => {
        file.uploading = false
        file.uploadFailed = true
      })
  }
} catch (error) {
  console.error('saved state was not a valid JSON, cleaning up')
  window.localStorage.removeItem('state')
}

const store =
  process.env.NODE_ENV === 'production'
    ? createStore(initialState)
    : devtools(createStore(initialState), {
        name: 'Instant Quote App',
        enabled: true
      })

store.subscribe((state) => window.localStorage.set('state', state))

export default store
